import { formatFullName } from '../../common/utils/userUtils';
import type { User } from '../../user/types/User';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sanitizeObject = (obj: any) => {
    const denyList = [
        'accessToken',
        'ssn',
        'accountNumber',
        'accountNumberMasked',
        'currentBalanceCents',
        'interestEarnedCents',
        'routingNumber',
        'totalAvailableBalanceCents',
        'totalInterestEarnedCents',
        'availableToWithdrawCents',
        'password',
        'session_jwt',
    ];

    const sanitizedObj = {};
    for (const key in obj) {
        // Check if the value is an object and not null, then recursively sanitize
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (typeof obj[key] === 'object' && obj[key] !== null) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            sanitizedObj[key] = sanitizeObject(obj[key]);
        } else {
            // Mask the value if the key is in the denyList
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
            sanitizedObj[key] = denyList.includes(key) ? '*****' : obj[key];
        }
    }
    return sanitizedObj;
};

export const isJSON = (str: string): boolean => {
    try {
        JSON.parse(str);
        return true;
    } catch (e) {
        return false;
    }
};

type IUserTraits = Record<string, string | number | boolean>;

export const getUserTraits = (user?: User): IUserTraits | undefined => {
    if (!user) {
        return undefined;
    }

    return {
        name: formatFullName(user.firstName, user.lastName),
        email: user.email,

        isSubscriptionActive: user.isSubscriptionActive ?? '',
        onboardingStatus: user.onboardingStatus,
        isVisitor: false, // Only true before user account creation
        ...(user.visitorId != null && user.visitorId !== ''
            ? { visitorId: user.visitorId } // For connecting events and sessions before/after user creation
            : {}),
    };
};
